import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { IUser } from '../interfaces';
import { UserService } from './';

const defaultPath = '/';
const defaultUser = null;

// const defaultUser = {
//   email: 'hamoadm@mekh.hu',
//   avatarUrl: 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/06.png'
// };

@Injectable()
export class AuthService {
  //  private _user: IUser | null = null;
  private _authForm = true;

  get loggedIn(): boolean {
    return !!this.userService.getUser(); // !!this._user;
  }

  get isAuthForm(): boolean {
    return !!this._authForm;
  }

  set isAuthForm(authForm: boolean) {
    this._authForm = authForm;
  }

  private _lastAuthenticatedPath: string = defaultPath;
  set lastAuthenticatedPath(value: string) {
    this._lastAuthenticatedPath = value;
  }

  constructor(private router: Router, private userService: UserService) {}

  async getUser() {
    try {
      return {
        isOk: true,
        data: this.userService.getUser(), // this._user
      };
    } catch {
      return {
        isOk: false,
        data: null,
      };
    }
  }

  async location(route: string): Promise<void> {
    this.router.navigate([route]);
  }

  async logOut() {
    this.userService.removeUser();
    window.location.reload();
  }
}

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isLoggedIn = this.authService.loggedIn;
    const isAuthForm = [
      'login-form',
      'create-account',
      //      'change-password:recoveryCode'
    ].includes(route.routeConfig?.path || defaultPath);

    // The following forms should be presented in single
    // card layout but it is used in outhenticated states
    this.authService.isAuthForm =
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ['change-password', 'reset-password', 'user-activation', 'user-inactivation'].includes(route.routeConfig!.path!) || false;

    if (isLoggedIn && isAuthForm) {
      this.authService.lastAuthenticatedPath = defaultPath;
      this.router.navigate([defaultPath]);
      return false;
    }

    if (!isLoggedIn && !isAuthForm) {
      this.router.navigate(['/login-form']);
    }

    if (isLoggedIn) {
      this.authService.lastAuthenticatedPath = route.routeConfig?.path || defaultPath;
    }

    return isLoggedIn || isAuthForm;
  }
}
